import { useRef } from 'react'
import { TimePickerInput } from './time-picker-input'
import { cn } from '@/lib/utils'

interface Props {
  value: Date

  onChange(value: Date): void
}

export function TimePicker({
  value,

  onChange,
}: Props) {
  const hoursRef = useRef<HTMLInputElement>(null)
  const minutesRef = useRef<HTMLInputElement>(null)

  return (
    <div
      className={cn(
        'grid grid-flow-col items-stretch',
        'focus-within:**:border-secondary'
      )}
    >
      <TimePickerInput
        className="border-r-0 rounded-r-none pr-0"
        value={value}
        picker="hours"
        ref={hoursRef}
        onRightFocus={() => minutesRef.current?.focus()}
        onChange={onChange}
      />

      <span className="inline-flex items-center border-y border-y-gray-200 transition-[border]">
        :
      </span>

      <TimePickerInput
        className="border-l-0 rounded-l-none pl-0"
        value={value}
        picker="minutes"
        ref={minutesRef}
        onLeftFocus={() => hoursRef.current?.focus()}
        onChange={onChange}
      />
    </div>
  )
}
